import { PreventDoubleClickDirective } from '@myre/ui-primitive-core';

import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { LinkComponent } from '../link/link.component';

@Component({
  selector: 'myre-click-or-link',
  templateUrl: './click-or-link.component.html',
  styleUrls: ['./click-or-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LinkComponent,
    RouterLink,
    NgTemplateOutlet,
    PreventDoubleClickDirective,
  ],
})
export class ClickOrLinkComponent {
  /**
   * Whether to use the link style or not
   */
  @Input()
  public useLinkStyle: boolean = false;

  /**
   * Traditional web link to open in another browser tab
   */
  @Input()
  public externalLink: string;

  /**
   * Internal router link to open in the same browser tab : https://angular.io/api/router/RouterLink
   */
  @Input()
  public link: any[] | string;

  /**
   * Query params to add to the router link : https://angular.io/guide/router-tutorial-toh#query-parameters
   */
  @Input()
  public queryParams: Record<string, any> = {};

  /**
   * Options to pass to the routerLinkActive directive : https://angular.io/api/router/RouterLinkActive
   */
  @Input()
  public routerLinkActiveOptions: {
    exact: boolean;
  } = {
    exact: false,
  };

  /**
   * Defines the value of the aria for accessibility
   */
  @Input('aria-label') public ariaLabel: string;

  /**
   * Event emitter to emit when the link is active
   */
  @Output('isRouterLinkActive')
  public isRouterLinkActiveEmitter: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  /**
   * Event emitter to emit when the link is clicked
   */
  @Output('onClick')
  public clickEmitter: EventEmitter<any> = new EventEmitter<any>();

  /**
   * @deprecated : use output isRouterLinkActive instead
   */
  public get active(): boolean {
    return this._isRouterLinkActive;
  }

  /**
   * @deprecated : Used only for the deprecated active method
   * @ignore
   */
  private _isRouterLinkActive = false;

  /**
   * @ignore
   */
  protected _routerLinkActive(isActive: boolean): void {
    this.isRouterLinkActiveEmitter.emit(isActive);
    this._isRouterLinkActive = isActive;
  }
}
